export const themePreset = [
  ['primaryColor', 'default'],
  ['logo', 'default']
];
const languagePreset = ['language', 'en'];

const presets = {
  login: [
    ['allowedConnections', ['Username-Password-Authentication', 'google-oauth2']],
    ['rememberLastLogin', false],
    ['socialButtonStyle', 'big'],
    ...themePreset,
    ['languageDictionary', { title: 'Auth0' }],
    languagePreset
  ]
};

export default presets;



// WEBPACK FOOTER //
// ./src/components/LockPlayground/theme-presets.js


// WEBPACK FOOTER //
// webpack:///src/components/LockPlayground/theme-presets.js